export default "__VITE_ASSET__BwJjQh4O__"